const ROUTE_VIEW_PIN_PREFIX = 'route-view:';

const getTabKey = (tab) => {
  if (tab?.value !== undefined && tab?.value !== null) {
    return String(tab.value);
  }

  return tab?.path ? String(tab.path) : null;
};

export const buildRouteViewPinId = (routeId, tab) => {
  const tabKey = getTabKey(tab);
  if (!routeId || !tabKey) return null;

  return `${ROUTE_VIEW_PIN_PREFIX}${encodeURIComponent(routeId)}:${encodeURIComponent(tabKey)}`;
};

export const getDatasetPinId = (dataset) => (
  buildRouteViewPinId(dataset?.id, dataset?.matchedTab) || dataset?.id || null
);

export const parseRouteViewPinId = (pinId) => {
  if (typeof pinId !== 'string' || !pinId.startsWith(ROUTE_VIEW_PIN_PREFIX)) {
    return null;
  }

  const encodedParts = pinId.slice(ROUTE_VIEW_PIN_PREFIX.length).split(':');
  if (encodedParts.length !== 2 || !encodedParts[0] || !encodedParts[1]) {
    return null;
  }

  try {
    return {
      routeId: decodeURIComponent(encodedParts[0]),
      tabKey: decodeURIComponent(encodedParts[1]),
    };
  } catch (_error) {
    return null;
  }
};

export const routeOrViewIsPinned = (routeId, pinnedRouteIds = []) => {
  return pinnedRouteIds.some((pinId) => {
    if (pinId === routeId) return true;
    return parseRouteViewPinId(pinId)?.routeId === routeId;
  });
};

export const resolveRouteViewPin = (pinId, routes = []) => {
  const parsedPin = parseRouteViewPinId(pinId);
  if (!parsedPin) return null;

  const parentRoute = routes.find((route) => route.id === parsedPin.routeId);
  if (!parentRoute) return null;

  const matchedTab = (parentRoute.tabs || []).find(
    (tab) => getTabKey(tab) === parsedPin.tabKey
  );
  if (!matchedTab) return null;

  const path = matchedTab.path
    || (matchedTab.value !== undefined && matchedTab.value !== null
      ? `${parentRoute.path}/${matchedTab.value}`
      : null);
  if (!path) return null;

  return {
    ...parentRoute,
    id: pinId,
    parentRouteId: parentRoute.id,
    path,
    label: matchedTab.label || parentRoute.label,
    sublabel: parentRoute.label,
    matchedTab,
    type: 'route-view-pin',
  };
};
